import { hasBranchClaim } from "./branch-claim";

/**
 * Where a user's access comes from when it's granted per request and never
 * stored as a grant, so anything resolved from stored grants (notification
 * recipients, report email recipients) leaves them out:
 *
 * - `"support"`: the support role, which makes the user a tenant admin.
 * - `"microsoftGroup"`: a Microsoft (Entra) group, carried in the access token.
 */
export type InheritedAccessReason = "support" | "microsoftGroup";

/** Support wins when both apply: it already makes the user a tenant admin everywhere. */
export function inheritedAccessReason(
  isSupportUser: boolean,
  accessToken: string | null,
): InheritedAccessReason | null {
  if (isSupportUser) return "support";
  return hasBranchClaim(accessToken) ? "microsoftGroup" : null;
}
